document.addEventListener('DOMContentLoaded', function () {
	//Accordion JS
	var acc = document.getElementsByClassName("course-accordion");
	var i;

	for (i = 0; i < acc.length; i++) {
		acc[i].onclick = function () {
			var panel = this.nextElementSibling;
			var coursePanel = document.getElementsByClassName("course-panel");
			var courseAccordion = document.getElementsByClassName("course-accordion");
			var courseAccordionActive = document.getElementsByClassName("course-accordion active");

			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
				this.classList.remove("active");
			} else {
				for (var ii = 0; ii < courseAccordionActive.length; ii++) {
					courseAccordionActive[ii].classList.remove("active");
				}
				for (var iii = 0; iii < coursePanel.length; iii++) {
					this.classList.remove("active");
					coursePanel[iii].style.maxHeight = null;
				}
				panel.style.maxHeight = panel.scrollHeight + "px";
				this.classList.add("active");
			}
		}
	}


// the below js is used to hide a class when close is clicked
	document.querySelector(".close_arrow").querySelector("button").addEventListener("click", closeFunction);

	function closeFunction() {
		document.body.classList.add('countdown-closed');
		document.documentElement.style.setProperty('--countdown-bar-height', `0px`);
		document.querySelector(".countdown-condensed").style.display = "none";
	}


// The below js is used to click humberger Menu
	if (document.querySelectorAll(".header_hamburger").length) {
		document.querySelectorAll(".header_hamburger").forEach(function (element) {
			element.addEventListener("click", addClass);
		});
	}

	function addClass() {
		document.body.classList.add('open-menu');
		let sidePanelelement = document.querySelectorAll('.header-sidebar__main-panel .header-sidebar__linklist');
		sidePanelelement.forEach(function (ele) {
			if (sessionStorage.getItem("nav-title")) {
				let getTitle = sessionStorage.getItem("nav-title")
				if (ele.querySelector(`li [data-link="${getTitle}"]`)) {
					ele.querySelector(`li [data-link="${getTitle}"]`).click();
				}
				setTimeout(function () {
					sessionStorage.removeItem("nav-title");
				}, 800);
			} else {
				ele.querySelector('li a').click();
			}

			if (ele.querySelector('li [aria-current="page"]')) {
				ele.querySelector('li [aria-current="page"]').click();
			}

		});

		//On Hover Event For Sidebar Navigation
		if (document.querySelectorAll('#sidebar-menu .header-sidebar__sub-panel').length) {
			document.querySelectorAll('#sidebar-menu .header-sidebar__sub-panel').forEach(function (element) {
				element.querySelectorAll('.header-sidebar__linklist li').forEach(function (Element) {

					Element.addEventListener('mouseover', function (Ele) {
						//let scrollHeight = 0;
						// console.log(Ele.currentTarget.querySelector('.header-sidebar__nested-linklist').scrollHeight)
						if (Ele.currentTarget.querySelector('.header-sidebar__nested-linklist')) {
							let scrollHeight = Ele.currentTarget.querySelector('.header-sidebar__nested-linklist').scrollHeight + 50;
							Ele.currentTarget.closest('.header-sidebar__scroller').style.minHeight = `${scrollHeight}px`;

							const currentElement = Ele.currentTarget.closest('.header-sidebar__linklist');
							if (currentElement) {
								currentElement.querySelectorAll('li details').forEach(function (element) {
									if (element !== Ele.currentTarget && element.hasAttribute('open')) {
										element.removeAttribute('open');
									}
								}, Ele.currentTarget);
							}
						}

						element.querySelectorAll('.header-sidebar__linklist li').forEach(function (El) {
							El.classList.remove('currentActive');
							if (El.querySelector('details')) {
								El.querySelector('details').removeAttribute('open');
							}
						})
						if (Ele.currentTarget.querySelector('details')) {
							Ele.currentTarget.classList.add('currentActive');
							Ele.currentTarget.querySelector('details').setAttribute('open', true);
						}
					})
				})
			});
		}

	}

//Slide Homepage slider on click Menu
	if (document.querySelector('.header__primary-nav')) {
		document.querySelector('.header__primary-nav').querySelectorAll('.header__primary-nav-item').forEach(function (ele) {
			ele.addEventListener('click', function (Element) {
				let getTitle = Element.currentTarget.getAttribute('data-title');
				let targetSlide = document.querySelector(`.main-slider[data-nav-title="${getTitle}"]`);
				console.log(getTitle)
				if (targetSlide) {
					Element.preventDefault();
					if (targetSlide) {
						let swiperMain = document.querySelector(".swiper_main");
						swiperMain.swiper.slides.forEach((slide, index) => {
							if (slide.querySelector('.main-slider').dataset.navTitle == getTitle) {
								swiperMain.swiper.slideTo(index);
							}
						});
						sessionStorage.setItem("nav-title", getTitle);
					}
				}
			})
		});
	}


//Drawer Close After Click on continue shopping Btn
	window.continueShopingBtn = function continueShopingBtn() {
		if (document.querySelectorAll('.js-continue-shoping').length) {
			document.querySelector("#cart-drawer").shadowRoot.querySelector("button").click();
		}
	}


// Clear All Filter Event In Drawer, excepto disponibilidad
window.facetClear = function facetClear() {
    if (document.querySelector('.js-facets-cart-clear')) {
        document.querySelector('.js-facets-cart-clear').addEventListener('click', function () {
            // Simular el clic para borrar todos los filtros
            if (document.querySelector(".collection__main")) {
                const clearAllButton = document.querySelector(".collection__main").querySelector('.active-facets .facets-clear-all');
                if (clearAllButton) {
                    clearAllButton.click(); // Borrar todos los filtros
                }

                // Mantener el filtro de disponibilidad activado
                const availabilityFilter = document.querySelector("input[name='filter.v.availability'][value='1']");
                if (availabilityFilter) {
                    availabilityFilter.checked = true; // Asegurarse de que el filtro de disponibilidad siga marcado
                }
            }

            // Crear una nueva URL con el filtro de disponibilidad
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            // Asegurarse de que el filtro de disponibilidad esté en la URL
            params.set('filter.v.availability', '1');

            // Actualizar la URL y recargar la página con el filtro de disponibilidad activo
            window.location.href = `${url.pathname}?${params.toString()}`;
        });
    }
};

window.facetClear();

//Shop The look click on dots On PdP
	if (document.querySelectorAll('shop-the-look-desktop-carousel .tap-area').length) {
		let dots = document.querySelectorAll('shop-the-look-desktop-carousel .tap-area');
		let prevButton = document.querySelector('.js-prev');
		let nextButton = document.querySelector('.js-next');
		let currentDotIndex = 0;
		prevButton.addEventListener('click', () => {
			if (currentDotIndex > 0) {
				if (nextButton.hasAttribute("disabled")) nextButton.removeAttribute("disabled");
				dots[currentDotIndex].setAttribute('aria-current', 'false');
				currentDotIndex--;
				dots[currentDotIndex].setAttribute('aria-current', 'true');
				dots[currentDotIndex].click();
			} else {
				prevButton.setAttribute('disabled', 'disabled');
			}
		});

		nextButton.addEventListener('click', () => {
			if (currentDotIndex < dots.length - 1) {
				if (prevButton.hasAttribute("disabled")) prevButton.removeAttribute("disabled");
				dots[currentDotIndex].setAttribute('aria-current', 'false');
				currentDotIndex++;
				dots[currentDotIndex].setAttribute('aria-current', 'true');
				dots[currentDotIndex].click();
			} else {
				nextButton.setAttribute('disabled', 'disabled');
			}
		});
	}

	var tabLinks = document.querySelectorAll(".js-faq-btn");
	var tabContent = document.querySelectorAll(".faq__category_title");

	tabLinks.forEach(function (el) {
		el.addEventListener("click", openTabs);
	});

	function openTabs(el) {
		var btnTarget = el.currentTarget;
		let getId = btnTarget.getAttribute('data-block-id');
		let click_heading = document.querySelector(`[id="${getId}"]`);
		tabContent.forEach(function (el) {
			el.classList.remove("tab-active");
		});

		tabLinks.forEach(function (el) {
			el.classList.remove("is-active");
		});

		click_heading.classList.add("tab-active");
		btnTarget.classList.add("is-active");
	}


//HIDE SHOW PASSWORD ON EYE CLICK
	if (document.querySelectorAll('.show_password').length && document.querySelectorAll('.hide_password').length) {
		document.querySelectorAll('.show_password').forEach(function (ele) {
			ele.addEventListener('click', function (element) {
				element.currentTarget.classList.add('hidden');
				element.currentTarget.closest('.form-control').querySelector('.hide_password').classList.remove('hidden');
				let password = element.currentTarget.closest('.form-control').querySelector(`input`),
					type = password.getAttribute("type") === "password" ? "text" : "password";
				password.setAttribute("type", type);
			});
		});

		document.querySelectorAll('.hide_password').forEach(function (ele) {
			ele.addEventListener('click', function (element) {
				element.currentTarget.classList.add('hidden')
				element.currentTarget.closest('.form-control').querySelector('.show_password').classList.remove('hidden');
				let password = element.currentTarget.closest('.form-control').querySelector(`input`),
					type = password.getAttribute("type") === "password" ? "text" : "password";
				password.setAttribute("type", type);
			});
		});
	}


//Contact page Validation JS
	let contactFormId = document.querySelector('#contact_form');
	if (contactFormId) {
		contactFormId.querySelector('button').addEventListener('click', function (element) {
			document.getElementById('nameError').innerText = '';
			document.getElementById('emailError').innerText = '';
			document.getElementById('consultationError').innerText = '';
			document.getElementById('conceptError').innerText = '';

			let name = contactFormId.querySelector('[name="contact[name]"]').value.trim();
			let email = contactFormId.querySelector('[name="contact[email]"]').value.trim();
			let consultation = contactFormId.querySelector('[name="contact[body]"]').value.trim();

			if (name === '') {
				document.getElementById('nameError').innerText = 'se requiere nombre y apellido';
				return false;
			}

			let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (!emailRegex.test(email)) {
				document.getElementById('emailError').innerText = 'Dirección de correo electrónico no válida';
				return false;
			}

			if (document.querySelector("#mounth").value === '') {
				document.getElementById('conceptError').innerText = 'se requiere concepto';
				return false;
			}

			if (consultation === '') {
				document.getElementById('consultationError').innerText = 'Se requiere consulta';
				return false;
			}
			document.querySelector('#contact_form').submit();
			return true;
		});
	}


//Foundation page Slider And Events
	if (document.querySelector('.year-slider')) {
		new Flickity(document.querySelector('.year-slider'), {
			cellAlign: "left",
			contain: true,
			wrapAround: false,
			prevNextButtons: true,
			pauseAutoPlayOnHover: false,
			pageDots: false,
			draggable: true
		});
	}

	let foundationYearWrap = document.querySelector('.foundation-main-wrap'),
		foundationContentWrap = document.querySelector('.js-foundation-content-wrap');
	if (foundationYearWrap) {
		foundationYearWrap.querySelectorAll('.js-timeline-date-btn').forEach(function (Element) {
			Element.addEventListener('click', function (ele) {
				foundationYearWrap.querySelectorAll('.js-timeline-date-btn').forEach(function (element) {
					element.classList.remove('is-active');
				});
				ele.currentTarget.classList.add('is-active');

				let getYear = ele.currentTarget.getAttribute('data-year');
				foundationContentWrap.querySelectorAll('.text-component').forEach(function (contentElement) {
					if (contentElement.getAttribute('data-year') === getYear) {
						contentElement.classList.remove('hidden');
					} else {
						contentElement.classList.add('hidden');
					}
				});
			});
		});
	}

	//Register Page Silbon People Checkbox
	let PeopleCheckobox = document.getElementById('customer_tags');
	if (PeopleCheckobox) {
		PeopleCheckobox.addEventListener('change', (event) => {
			if (event.currentTarget.checked) {
				event.currentTarget.value = "SilbonPeople";
			} else {
				event.currentTarget.value = '';
			}
		});
	}


	
	
	


// side bar menu dragable //
	let mouseDown = false;
	let startX, scrollLeft;
	const slider = document.querySelector('.header-sidebar__scroller');

	const startDragging = (e) => {
		mouseDown = true;
		startX = e.pageX - slider.offsetLeft;
		scrollLeft = slider.scrollLeft;
	}

	const stopDragging = (e) => {
		mouseDown = false;
	}

	const move = (e) => {
		e.preventDefault();
		if (!mouseDown) {
			return;
		}
		const x = e.pageX - slider.offsetLeft;
		const scroll = x - startX;
		slider.scrollLeft = scrollLeft - scroll;
	}

// Add the event listeners
	slider.addEventListener('mousemove', move, false);
	slider.addEventListener('mousedown', startDragging, false);
	slider.addEventListener('mouseup', stopDragging, false);
	slider.addEventListener('mouseleave', stopDragging, false);
});
const openDrawerBtn = document.getElementById('openDrawerBtn');
document.addEventListener('DOMContentLoaded', function () {
	const openDrawerBtn = document.getElementById('openDrawerBtn');
	const closeDrawerBtn = document.getElementById('closeDrawerBtn');
	const drawer = document.getElementById('drawer');
	const overlay = document.getElementById('overlay');

	if (openDrawerBtn) {
		openDrawerBtn.addEventListener('click', () => {
			drawer.classList.add('opened');
			overlay.classList.add('opened');
			document.body.classList.add('drawer-opened'); // Add class to body
		});
	}

	if (closeDrawerBtn) {
		closeDrawerBtn.addEventListener('click', () => {
			closeDrawer();
		});
	}

	if (overlay) {
		overlay.addEventListener('click', () => {
			closeDrawer();
		});
	}

	function closeDrawer() {
		drawer.classList.remove('opened');
		overlay.classList.remove('opened');
		document.body.classList.remove('drawer-opened'); // Remove class from body
	}

	function toggleDrawer() {
		var body = document.querySelector("body");
		var overlay = document.getElementById("drawer_customer_registrate_main_overlay");
		var hasClass = body.classList.contains("drawer_customer_registrate_main");

		if (!hasClass) {
			body.classList.add("drawer_customer_registrate_main"); // Add the specified class to body
		} else {
			body.classList.remove("drawer_customer_registrate_main"); // Remove the specified class from body
		}
	}

	window.addEventListener('scroll', function () {
		let stickyHeaderOffset = parseFloat(document.querySelector('html').style.getPropertyValue('--header-height'));

		let checkElementInView = function (element) {
			if (element) {
				let elementOffsetTop = parseFloat(element.offsetTop),
					elementHeight = parseFloat(element.offsetHeight),
					windowHeight = window.innerHeight,
					scrollTop = window.scrollY;

				return scrollTop + windowHeight > elementOffsetTop && scrollTop < elementOffsetTop + elementHeight;
			}
			return false;
		};

		let newsletterElement = document.querySelector('.shopify-section-group-footer-group');
		let iconWithHorizontalElement = document.querySelector('.icon_with_horizontal');
		let footerElement = document.querySelector('.footer');

		let isNewsletterInView = checkElementInView(newsletterElement);
		let isIconWithHorizontalInView = checkElementInView(iconWithHorizontalElement);
		let isFooterInView = checkElementInView(footerElement);

		// if (isNewsletterInView || isIconWithHorizontalInView || isFooterInView) {
		// 	document.body.classList.add('header_not_sticky');
		// } else {
		// 	document.body.classList.remove('header_not_sticky');
		// }
	});

	document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
	if (Shopify.designMode) {
		document.documentElement.classList.add('shopify-design-mode');
	}
	document.documentElement.style.setProperty('--viewport-height', window.visualViewport.height + 'px');
	document.documentElement.style.setProperty('--viewport-width', window.visualViewport.width + 'px');

	var initialWidth = window.visualViewport.width;
	window.addEventListener('resize', function () {
		var newWidth = window.visualViewport.width;
		if (newWidth !== initialWidth) {
			document.documentElement.style.setProperty('--viewport-height', window.visualViewport.height + 'px');
			document.documentElement.style.setProperty('--viewport-width', window.visualViewport.width + 'px');
		}
	});

	function getBroswerDetails() {
		//Checking the user's OS and Browser
		if ((navigator.userAgent).includes("Android")) {
			document.querySelector("html").classList.add("android");
		} else if ((navigator.userAgent).includes("Mac")) {
			document.querySelector("html").classList.add("mac");
		} else {
			document.querySelector("html").classList.add("windows");
		}


		//-- Browser --//
		var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
		var isFirefox = typeof InstallTrigger !== 'undefined';
		var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
			return p.toString() === "[object SafariRemoteNotification]";
		})(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
		var isIE = /*@cc_on!@*/ false || !!document.documentMode;
		var isEdge = !isIE && !!window.StyleMedia;
		var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
		var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
		var isBlink = (isChrome || isOpera) && !!window.CSS;
		if (isFirefox) {
			document.querySelector("html").classList.add("isFirefox")
		} else if (isChrome) {
			document.querySelector("html").classList.add("isChrome")
		} else if (isSafari) {
			document.querySelector("html").classList.add("isSafari")
		} else if (isOpera) {
			document.querySelector("html").classList.add("isOpera")
		} else if (isIE) {
			document.querySelector("html").classList.add("isIE")
		} else if (isEdge) {
			document.querySelector("html").classList.add("isEdge")
		} else if (isEdgeChromium) {
			document.querySelector("html").classList.add("isEdgeChromium")
		} else {
			document.querySelector("html").classList.add("isBlink")
		}
	}

	getBroswerDetails();

	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		// true for mobile device
		document.querySelector("html").classList.add("mobile");
	}
});
